import * as React from 'react';
import {transparentize} from 'polished';
import styled from 'styled-components';
import {
  BlockLabel as Label,
  BlockTitle,
} from '../components/styled';
import {CoursePromoContext} from '../context';

const Container = styled.div`
  padding: 0 60px;

  @media screen and (max-width: 640px) {
    padding: 40px 16px 40px 16px;
  }
`;

const Title = styled(BlockTitle)`
  margin-bottom: 40px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 55px;
  grid-row-gap: 44px;
  
  @media screen and (max-width: 940px) {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 20px;
  }
  
  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

const Item = styled.div`
  max-width: 338px;
  line-height: 24px;
  color: ${({theme}) => `
    ${transparentize(.2, theme.colors.white)};
  `};

  @media screen and (max-width: 640px) {
    max-width: 100%;
  }

  &::before {
    content: '';
    display: block;
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='30' height='30' rx='15' fill='%233264EF'/%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M13 19L17 15L13 11' stroke='white' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='14' height='6' fill='white' transform='translate(12 22) rotate(-90)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
`;

/**
 * The returns course benefit component
 * @return {React.ReactElement}
 * @constructor
 */
export default function Benefit(): React.ReactElement {
  const {benefit} = React.useContext(CoursePromoContext);

  /**
   * Render course benefit content
   * @return {React.ReactNodeArray}
   * @constructor
   */
  function renderContent(): React.ReactNodeArray {
    return benefit.items.map(renderItem);
  }

  /**
   * Render course benefit item
   * @param {string} title
   * @param {number} ind
   * @constructor
   */
  function renderItem(title: string, ind: number) {
    return (
      <Item key={ind + title}>
        {title}
      </Item>
    );
  }

  return (
    <Container>
      <Label>Польза</Label>
      <Title>
        {benefit.title}
      </Title>
      <Content>
        {renderContent()}
      </Content>
    </Container>
  );
}
